import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { toggleCartHidden } from "../../redux/cart/cart.actions";
import { selectCartItemsCount } from "../../redux/cart/cart.selectors";

import { CartContainer, ShoppingIcon, ItemCountContainer, TitleContainer } from "./cart-icon.styles";

export const CartIcon = ({ toggleCartHidden, itemCount, title }) => (
	<CartContainer onClick={toggleCartHidden} onMouseDown={(e) => {
        // prevent triggering blur
        e.preventDefault()
      }}>
		<TitleContainer>{title}</TitleContainer>
		<ShoppingIcon />
		<ItemCountContainer>{itemCount}</ItemCountContainer>
	</CartContainer>
);

const mapDispatchToProps = (dispatch) => ({
	toggleCartHidden: () => dispatch(toggleCartHidden()),
});

const mapStateToProps = createStructuredSelector({
	itemCount: selectCartItemsCount,
});

export default connect(mapStateToProps, mapDispatchToProps)(CartIcon);
